<template>
  <section :class="$style.item">
    <CheckCircle :class="$style.item__icon" />
    <div :class="[$style.item__contents, $style.contents]">
      <p :class="$style.contents__todo">{{ item.title }}</p>
      <p :class="$style.contents__description">{{ item.description }}</p>
    </div>
    <RouterLink
      v-if="isInternalLinkType(item.link)"
      :class="[$style.todo__link, $style.link]"
      :to="item.link.to"
      @click="item.link.onClick"
      >{{ item.link.text }}</RouterLink
    >
    <ExternalLink
      v-else-if="isExternalLinkType(item.link)"
      :class="[$style.todo__link, $style.link]"
      :href="item.link.href"
      @click="item.link.onClick"
      noIcon
      >{{ item.link.text }}</ExternalLink
    >
  </section>
</template>

<script setup lang="ts">
import CheckCircle from '@/assets/images/icons/check.svg?component'
import ExternalLink from '@/components/atoms/ExternalLink.vue'
import type { TodoItem } from './type'
import { isInternalLinkType, isExternalLinkType } from '@/libs/utilities/link'

defineProps<{ item: TodoItem }>()
</script>

<style lang="scss" module>
.item {
  display: flex;
  width: 100%;
  padding: 32px 0;

  &__icon {
    width: 20px;
    height: 20px;
  }

  &__contents {
    flex-grow: 1;
  }
}

.contents {
  margin-left: 8px;

  :nth-child(n + 2) {
    margin-top: 4px;
  }

  &__todo {
    color: $color-text-and-object-high-emphasis;
    font-size: 16px;
    font-weight: bold;
  }

  &__description {
    color: $color-text-and-object-medium-emphasis;
    font-size: 14px;
  }
}

.link {
  padding: 12px 0;
  color: $color-text-and-object-accent-primary;

  &:hover {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
